import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const REVIEW_STATUS = ['PENDING', 'APPROVED', 'REJECTED'] as const;

export type ReviewStatus = (typeof REVIEW_STATUS)[number];

export const PENDING_REVIEW_STATUS = 'PENDING' satisfies ReviewStatus;

export const REVIEW_STATUS_LABELS: Record<ReviewStatus, string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const REVIEW_STATUS_TONE: Record<ReviewStatus, StatusColorTone> = {
  PENDING: APPROVAL_STATUS_TONE.pending,
  APPROVED: APPROVAL_STATUS_TONE.approved,
  REJECTED: APPROVAL_STATUS_TONE.rejected,
};
